<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Wrapper -->
<div class="flex w-full flex-auto flex-col">

    <div class="ml-auto m-3 flex items-center space-x-0.5 pl-2 sm:space-x-2">
        <settings></settings>
    </div>

    <!-- Content -->
    <div class="flex flex-auto flex-col">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->

        @if (true) {
            <router-outlet></router-outlet>
        }
    </div>
</div>
